const nestable = {
  init(el, binding, vnode) {
    const hasPointerEvents = (function pointer() {
      const el = document.createElement('div');
      const docEl = document.documentElement;
      if (!('pointerEvents' in el.style)) {
        return false;
      }
      el.style.pointerEvents = 'auto';
      el.style.pointerEvents = 'x';
      docEl.appendChild(el);
      const supports = window.getComputedStyle &&
            window.getComputedStyle(el, '').pointerEvents === 'auto';
      docEl.removeChild(el);
      return !!supports;
    })();

    const defaults = {
      listNodeName: 'ol',
      itemNodeName: 'li',
      rootClass: 'dd',
      listClass: 'dd-list',
      itemClass: 'dd-item',
      dragClass: 'dd-dragel',
      handleClass: 'dd-handle',
      collapsedClass: 'dd-collapsed',
      placeClass: 'dd-placeholder',
      noDragClass: 'dd-nodrag',
      emptyClass: 'dd-empty',
      maxDepth: 5,
      fn: 'rearrangeLinks',
      threshold: 20,
    };

    const extend = (d, o) => {
      const extended = {};
      let prop;
      for (prop in d) {
        if (Object.prototype.hasOwnProperty.call(d, prop)) {
          extended[prop] = d[prop];
        }
      }
      for (prop in o) {
        if (Object.prototype.hasOwnProperty.call(o, prop)) {
          extended[prop] = o[prop];
        }
      }
      return extended;
    };

    Element.prototype.previous = function(sel) {
      if (this.parentNode !== null) {
        const siblings = this.parentNode.children;
        const elIndex = [].indexOf.call(siblings, this);
        const tag = new RegExp(sel, 'gi');
        for (let i = siblings.length; i > -1; i -= 1) {
          const sibling = siblings[i];
          if (i < elIndex) {
            if (sibling.tagName.match(tag) || sibling.classList.contains(sel)) {
              return sibling;
            }
          }
        }
      }
    };

    Element.prototype.next = function (sel) {
      if (this.parentNode !== null) {
        const siblings = this.parentNode.children;
        const elIndex = [].indexOf.call(siblings, this);
        const tag = new RegExp(sel, 'gi');
        for (let i = 0; i < siblings.length; i++) {
          const sibling = siblings[i];
          if (i > elIndex) {
            if (sibling.tagName.match(tag) || sibling.classList.contains(sel)) {
              return sibling;
            }
          }
        }
      }
    };

    Element.prototype.parents = function (selector) {
      const elements = [];
      let el = this;
      const ishaveselector = selector !== undefined;

      while ((el = el.parentElement) !== null) {
        if (el.nodeType !== Node.ELEMENT_NODE) {
          continue;
        }

        if (!ishaveselector || el.matches(selector)) {
          elements.push(el);
        }
      }
      return elements;
    };

    Element.prototype.chldrn = function (selector) {
      let elements = [];
      const el = this;
      const tag = new RegExp(selector, 'gi');
      if (selector) {
        for (let i = 0; i < el.children.length; i++) {
          const child = el.children[i];
          if (child.tagName.match(tag) || child.classList.contains(selector)) {
            elements.push(child);
          }
        }
      } else {
        elements = el.children;
      }
      return elements;
    };

    Element.prototype.offSet = function() {
      const rect = this.getBoundingClientRect();
      const body = document.body;
      return {
        top: rect.top + body.scrollTop,
        left: rect.left + body.scrollLeft,
        height: rect.height,
      };
    };

    Element.prototype.after = function(el) {
      if (this !== null && this.parentNode !== null) {
        this.parentNode.insertBefore(el, this.nextSibling);
      }
    };

    Element.prototype.before = function(el) {
      if (this !== null && this.parentNode !== null) {
        this.parentNode.insertBefore(el, this);
      }
    };

    const actions = {
      activeNode: null,
      activeId: null,
      activeOldParent: null,
      activeNewParent: null,
      newIndex: null,
      oldIndex: null,
      init() {
        const list = this;
        list.reset();
        list.placeEl = document.createElement('div');
        list.placeEl.classList.add(list.options.placeClass);

        const initialClick = () => {
          if (list.dragEl) {
            return;
          }
        };

        list.el.removeEventListener('click', initialClick, false);
        list.el.addEventListener('click', initialClick, false);

        const onStartEvent = (e) => {
          const handle = e.target;
          if (handle.classList.contains(list.options.handleClass)) {
            this.activeNode = handle.parentNode;
            this.activeOldParent = this.activeNode
              .parentNode
              .parentNode.getAttribute('nestable-item-id');
            this.activeId = handle.parentNode.getAttribute('nestable-item-id');

            this.oldIndex = [].indexOf.call(this.activeNode.parentNode.children, this.activeNode);

            list.isTouch = /^touch/.test(e.type);
            if (list.isTouch && e.touches.length !== 1) {
              return;
            }
            e.preventDefault();
            list.dragStart(e.touches ? e.touches[0] : e);
          }
        };

        const onMoveEvent = (e) => {
          if (list.dragEl) {
            e.preventDefault();
            list.dragMove(e.touches ? e.touches[0] : e);
          }
        };

        const onEndEvent = (e) => {
          if (list.dragEl) {
            e.preventDefault();
            list.dragStop(e.touches ? e.touches[0] : e);
          }
        };

        list.el.removeEventListener('mousedown', onStartEvent, false);
        list.el.addEventListener('mousedown', onStartEvent, false);

        document.removeEventListener('mousemove', onMoveEvent, false);
        document.addEventListener('mousemove', onMoveEvent, false);

        document.removeEventListener('mouseup', onEndEvent, false);
        document.addEventListener('mouseup', onEndEvent, false);
      },
      reset() {
        this.mouse = {
          offsetX: 0,
          offsetY: 0,
          startX: 0,
          startY: 0,
          lastX: 0,
          lastY: 0,
          nowX: 0,
          nowY: 0,
          distX: 0,
          distY: 0,
          dirAx: 0,
          dirX: 0,
          dirY: 0,
          lastDirX: 0,
          lastDirY: 0,
          distAxX: 0,
          distAxY: 0,
        };
        this.isTouch = false;
        this.moving = false;
        this.dragEl = null;
        this.dragRootEl = null;
        this.dragDepth = 0;
        this.hasNewRoot = false;
        this.pointEl = null;
      },
      dragStart(e) {
        window.addEventListener('mousemove', actions.autoScroll, false);
        const inMotion = document.getElementById('dd-in-motion');
        // make sure this doesn't keep adding new nodes inside the body
        if (inMotion === null) {
          const mouse = this.mouse;
          const target = e.target;
          const dragItem = target.closest(this.options.itemNodeName);

          if (dragItem !== null) {
            this.placeEl.style.height = `${dragItem.offsetHeight}px`;
          }

          const targetPos = target.getBoundingClientRect();
          mouse.offsetX = e.offsetX !== undefined ? e.offsetX : e.pageX - targetPos.left;
          mouse.offsetY = e.offsetY !== undefined ? e.offsetY : e.pageY - targetPos.top;
          mouse.startX = mouse.lastX = e.pageX;
          mouse.startY = mouse.lastY = e.pageY;

          this.dragRootEl = this.el;

          this.dragEl = document.createElement(this.options.listNodeName);
          this.dragEl.classList.add(this.options.listClass, this.options.dragClass);

          if (dragItem !== null) {
            this.dragEl.style.width = `${dragItem.offsetWidth}px`;
          }

          if (dragItem !== undefined && dragItem !== null) {
            dragItem.after(this.placeEl);
            dragItem.parentNode.removeChild(dragItem);
            this.dragEl.appendChild(dragItem);
            this.dragEl.id = 'dd-in-motion';
          }
          document.body.appendChild(this.dragEl);
          this.dragEl.style.left = `${e.pageX - mouse.offsetX}px`;
          this.dragEl.style.top = `${e.pageY - mouse.offsetY}px`;
          // total depth of dragging item
          let depth;
          const items = this.dragEl.querySelectorAll(this.options.itemNodeName);

          for (let i = 0; i < items.length; i++) {
            depth = items[i].parents(this.options.listNodeName).length;
            if (depth > this.dragDepth) {
              this.dragDepth = depth;
            }
          }
        }
      },
      dragStop() {
        window.removeEventListener('mousemove', actions.autoScroll, false);
        const el = this.dragEl.chldrn(this.options.itemNodeName);
        if (el.length) {
          el[0].parentNode.removeChild(el[0]);
          this.placeEl.parentNode.replaceChild(el[0], this.placeEl);
        }
        this.dragEl.parentNode.removeChild(this.dragEl);
        this.reset();
        this.newIndex = [].indexOf.call(this.activeNode.parentNode.children, this.activeNode);
        this.activeNewParent = this.activeNode.parentNode.parentNode.getAttribute('nestable-item-id');
        // send off payload to component
        vnode.context[this.options.fn]({
          activeId: this.activeId,
          activeNewParent: this.activeNewParent,
          activeOldParent: this.activeOldParent,
          newIndex: this.newIndex,
          oldIndex: this.oldIndex,
        });
      },
      dragMove(e) {
        let list;
        let prev;
        let next;
        let depth;
        let parent;
        const opt = this.options;
        const mouse = this.mouse;

        this.dragEl.style.left = `${e.pageX - mouse.offsetX}px`;
        this.dragEl.style.top = `${e.pageY - mouse.offsetY}px`;

        // mouse position last events
        mouse.lastX = mouse.nowX;
        mouse.lastY = mouse.nowY;
        // mouse position this events
        mouse.nowX = e.pageX;
        mouse.nowY = e.pageY;
        // distance mouse moved between events
        mouse.distX = mouse.nowX - mouse.lastX;
        mouse.distY = mouse.nowY - mouse.lastY;
        // direction mouse was moving
        mouse.lastDirX = mouse.dirX;
        mouse.lastDirY = mouse.dirY;
        // direction mouse is now moving (on both axis)
        mouse.dirX = mouse.distX === 0 ? 0 : mouse.distX > 0 ? 1 : -1;
        mouse.dirY = mouse.distY === 0 ? 0 : mouse.distY > 0 ? 1 : -1;
        // axis mouse is now moving on
        const newAx = Math.abs(mouse.distX) > Math.abs(mouse.distY) ? 1 : 0;

        // do nothing on first move
        if (!mouse.moving) {
          mouse.dirAx = newAx;
          mouse.moving = true;
          return;
        }

        // calc distance moved on this axis (and direction)
        if (mouse.dirAx !== newAx) {
          mouse.distAxX = 0;
          mouse.distAxY = 0;
        } else {
          mouse.distAxX += Math.abs(mouse.distX);
          if (mouse.dirX !== 0 && mouse.dirX !== mouse.lastDirX) {
            mouse.distAxX = 0;
          }
          mouse.distAxY += Math.abs(mouse.distY);
          if (mouse.dirY !== 0 && mouse.dirY !== mouse.lastDirY) {
            mouse.distAxY = 0;
          }
        }
        mouse.dirAx = newAx;
        // Move horizontal
        if (mouse.dirAx && mouse.distAxX >= opt.threshold) {
          // reset move distance on x-axis for new phase
          mouse.distAxX = 0;
          prev = this.placeEl.previous(opt.itemNodeName);
          // increase horizontal level if previous sibling exists and is not collapsed
          if (mouse.distX > 0 && prev !== undefined &&
              !prev.classList.contains(opt.collapsedClass)) {
            // cannot increase level when item above is collapsed
            list = prev.querySelectorAll(`${opt.listNodeName}:last-child`);
            // check if depth limit has reached
            depth = this.placeEl.parents(opt.listNodeName).length;
            if (depth + this.dragDepth <= opt.maxDepth) {
              // create new sub-level if one doesn't exist
              if (!list.length) {
                list = document.createElement(opt.listNodeName);
                list.classList.add(opt.listClass);
                list.appendChild(this.placeEl);
                prev.appendChild(list);
              } else {
                // else append to next level up
                list = prev.querySelectorAll(`${opt.listNodeName}:last-child`)[0];
                list.appendChild(this.placeEl);
              }
            }
          }
          // decrease horizontal level
          if (mouse.distX < 0) {
            // we can't decrease a level if an item preceeds the current one
            next = this.placeEl.next(opt.itemNodeName);
            if (next === undefined) {
              parent = this.placeEl.parentNode;
              const closestNode = this.placeEl.closest(opt.itemNodeName);
              if (closestNode !== null) {
                closestNode.after(this.placeEl);
              }
            }
          }
        }

        let isEmpty = false;
        // find list item under cursor
        if (!hasPointerEvents) {
          this.dragEl[0].style.visibility = 'hidden';
        }
        this.pointEl = document.elementFromPoint(
          e.pageX - document.body.scrollLeft,
          e.pageY - (window.pageYOffset || document.documentElement.scrollTop));
        if (!hasPointerEvents) {
          this.dragEl[0].style.visibility = 'visible';
        }
        if (this.pointEl !== null && this.pointEl.classList.contains(opt.handleClass)) {
          this.pointEl = this.pointEl.parentNode;
        }
        if (this.pointEl !== null && this.pointEl.classList.contains(opt.emptyClass)) {
          isEmpty = true;
        } else if (this.pointEl !== null && !this.pointEl.classList.contains(opt.itemClass)) {
          return;
        }
        // find parent list of item under cursor
        if (this.pointEl !== null) {
          const pointElRoot = this.pointEl.closest(`.${opt.rootClass}`);
        }
        // Move vertical
        if (this.pointEl !== null && !mouse.dirAx || isEmpty) {
          // check depth limit
          depth = this.dragDepth - 1 + this.pointEl.parents(opt.listNodeName).length;
          if (depth > opt.maxDepth) {
            return;
          }
          const before = e.pageY < (this.pointEl.offSet().top + this.pointEl.offSet().height / 2);
          parent = this.placeEl.parentNode;
          // if empty create new list to replace empty placeholder
          if (isEmpty) {
            list = document.createElement(opt.listNodeName);
            list.classList.add(opt.listClass);
            list.appendChild(this.placeEl);
            this.pointEl.parentNode.replaceChild(list, this.pointEl);
          } else if (before) {
            this.pointEl.before(this.placeEl);
          } else {
            this.pointEl.after(this.placeEl);
          }
          if (!this.dragRootEl.querySelectorAll(opt.itemNodeName).length) {
            const emptyDiv = document.createElement('div');
            emptyDiv.classList.add(opt.emptyClass);
            this.dragRootEl.appendChild(emptyDiv);
          }
        }
      },
      mouseStart: 0,
      scrollAmount: 4,
      direction: null,
      autoScroll() {
        const inMotion = document.getElementById('dd-in-motion');
        // disallow unless there is something being dragged
        if (inMotion === null) {
          window.removeEventListener('mousemove', actions.autoScroll, false);
        }
        // console.log('checking');
        // determine if mouse is moving up or down
        if (event.pageY < this.mouseStart) {
          this.direction = 'up';
        }
        if (event.pageY > this.mouseStart) {
          this.direction = 'down';
        }
        this.mouseStart = event.pageY;
        // if this is scrolling within a container
        if (binding.value && binding.value.scrollContainer) {
          const container = document.querySelectorAll(binding.value.scrollContainer)[0];
          // scrolling up in container
          if (event.pageY < (window.scrollY) + 65 && this.direction === 'up') {
            container.scrollTop -= actions.scrollAmount;
          }
          // scrolling to bottom of container
          if (event.pageY > (container.offsetHeight + window.scrollY) - 20 && this.direction === 'down') {
            container.scrollTop += actions.scrollAmount;
          }
        } else {
          // Default scrolling on window
          // when reaching the top edge of the screen
          if (event.pageY < (window.scrollY) + 65 && this.direction === 'up') {
            window.scrollBy(0, -(actions.scrollAmount));
          }
          if (event.pageY > (window.innerHeight + window.scrollY) - 20 && this.direction === 'down') {
            // only allow more scrolling if not reached the end of the page
            if ((window.innerHeight + window.scrollY) < document.body.offsetHeight) {
              window.scrollBy(0, actions.scrollAmount);
            }
          }
        }
      },
    };

    // init the plugin
    actions.el = el;
    actions.options = extend(defaults, binding.value);
    actions.init();
  },
};

export { nestable };



// WEBPACK FOOTER //
// ./src/directives/nestable.js